import Button from '@ui/Button'
import { useEffect ,useRef,useState,useId } from 'react'
import Breadcrumb from '@common/Breadcrumb'
import { ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import MetaInfo from '@/components/common/MetaInfo'
import StackGrid from '@components/StackGrid'
import { buildRows, useScrollStack } from '../assets/js/common'
   import { usePrefersReducedMotion } from '@helpers/usePrefersReducedMotion'
   import { metaTitleFor } from '../assets/js/navBreadcrumb'
   const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.SECURITY_COMPLIANCE_ADVISORY)
   
// function useScrollStack(containerRef, count) {
  
//   useEffect(() => {
//     const container = containerRef.current
//     if (!container) return
//     const cards = Array.from(container.querySelectorAll('.ss-card'))

//     // The sticky "stacked deck" illusion only exists at >=992px (see the
//     // matching @media (max-width: 991px) rule in main.css that turns off
//     // position:sticky on .ss-card). Below that, this effect must not run
//     // at all — otherwise cards visibly shrink/shift on every scroll even
//     // though there's no stack to sell the illusion for.
//     const mql = window.matchMedia('(min-width: 992px)')

//     const clearTransforms = () => {
//       cards.forEach((card) => { card.style.transform = '' })
//     }

//     const onScroll = () => {
//       if (!mql.matches) return
//       const top  = container.getBoundingClientRect().top
//       const h    = container.offsetHeight
//       const winH = window.innerHeight
//       cards.forEach((card, i) => {
//         const progress = Math.max(0, Math.min(1, (-top + i * (winH * 0.3)) / (h - winH)))
//         if (progress >= 1) {
//           card.style.transform = 'scale(0.94) translateY(-24px)'
//         } else if (progress > 0) {
//           card.style.transform = `scale(${1 - progress * 0.06}) translateY(${-(progress * 24)}px)`
//         } else {
//           card.style.transform = 'scale(1) translateY(0)'
//         }
//       })
//     }

//     const onBreakpointChange = () => {
//       if (!mql.matches) clearTransforms()
//       onScroll()
//     }

//     window.addEventListener('scroll', onScroll, { passive: true })
//     window.addEventListener('resize', onBreakpointChange)
//     // Safari <14 only supports the older addListener/removeListener API.
//     if (mql.addEventListener) mql.addEventListener('change', onBreakpointChange)
//     else mql.addListener(onBreakpointChange)
//     onBreakpointChange()

//     return () => {
//       window.removeEventListener('scroll', onScroll)
//       window.removeEventListener('resize', onBreakpointChange)
//       if (mql.removeEventListener) mql.removeEventListener('change', onBreakpointChange)
//       else mql.removeListener(onBreakpointChange)
//     }
//   }, [containerRef, count])
// }

// Turns **bold** markers into <b> elements (no raw HTML injection)
const renderBold = (text) =>
  text.split('**').map((part, i) =>
    i % 2 ? <span key={i} className="text-bold text-italic">{part}</span> : part
  )
  
// section2
const WEB_APPLICATION = [
   { id: 1, icon: 'fa-building-columns', title: 'GIGW Readiness', desc: [
      'Support for **Guidelines for Indian Government Websites (GIGW)** requirements, including assessment of website quality, accessibility, security, usability, content, and related governance practices.',
      "GIGW is an important reference for Indian government websites, and STQC's Website Quality Certification Scheme incorporates GIGW requirements.",
  ] },
 { id: 2, icon: 'fa-shield-halved', title: 'VAPT / STQC Readiness & Advisory', desc: [
      'Help organizations prepare websites and web applications for relevant **STQC evaluation and certification processes**, including identification of quality, accessibility, security, and process-related gaps, VAPT (Vulnerability Assessment & Penetration Testing), WAPT (Web Application Penetration Testing).',
      "STQC's Website Quality Certification framework addresses areas including security hardening, accessibility, usability, and GIGW compliance.",
  ] },
  { id: 3, icon: 'fa-universal-access', title: 'WCAG Accessibility', desc: [
      'Design and assess web interfaces against **WCAG accessibility principles**, helping make digital platforms more accessible to users with diverse abilities.',
      "WCAG covers websites, web applications, and digital content, with conformance levels A, AA, and AAA.",
  ] },
  { id: 4, icon: 'fa-user-lock', title: 'DPDP Act Readiness', desc: [
      'Help organizations review how digital personal data is collected, processed, stored, accessed, and protected within their applications and technology ecosystem.',
      "The **Digital Personal Data Protection Act, 2023** establishes a framework for processing digital personal data while recognizing individuals' rights over their personal data. The DPDP Rules, 2025 provide additional operational requirements and were notified by MeitY in November 2025.",
  ] },
]
// section3
const ASSESSMENT_AREAS = [
  {icon:'fa-solid fa-lock', title: 'Application Security',             desc: 'Review authentication, authorization, session management, input validation, data handling, APIs, and other application-level security considerations.' },
  {icon:'fa-solid fa-triangle-exclamation', title: 'Vulnerability & Risk Assessment',  desc: 'Identify potential weaknesses across applications, databases, infrastructure, and integrations and help prioritize remediation based on risk.' },
  {icon:'fa-solid fa-database', title: 'Data Protection',                  desc: 'Assess how sensitive and personal data moves through your applications and systems, with focus on appropriate access, storage, processing, and protection practices.' },
  {icon:'fa-solid fa-key', title: 'Access & Identity Controls',       desc: 'Review user roles, privileges, authentication mechanisms, administrative access, and authorization controls to reduce unnecessary exposure.' },
  {icon:'fa-solid fa-plug', title: 'API & Integration Security',       desc: 'Evaluate APIs and integrations for appropriate authentication, authorization, data protection, and secure communication.' },
  {icon:'fa-solid fa-people-group', title: 'Accessibility & Inclusive Design', desc: 'Assess digital interfaces against applicable accessibility requirements and WCAG principles to improve usability for users with different abilities.' },
]
//section 4
const PRACTICAL_ACTION = [
  { num: '01', icon: 'fa-solid fa-clipboard-list',               title: 'Assess', desc: 'Understand your application, infrastructure, data, and existing controls.' },
  { num: '02', icon: 'fa-solid fa-magnifying-glass', title: 'Identify',     desc: 'Highlight security vulnerabilities, accessibility issues, privacy concerns, and compliance gaps.' },
  { num: '03', icon: 'fa-solid fa-arrow-down-wide-short',              title: 'Prioritize',  desc: 'Categorize findings based on severity, business impact, and applicable requirements.' },
  { num: '04', icon: 'fa-solid fa-screwdriver-wrench',                  title: 'Remediate',    desc: 'Define practical technical and process-level recommendations.' },
  { num: '05', icon: 'fa-solid fa-circle-check',                 title: 'Validate',     desc: 'Reassess improvements and prepare for relevant audits, evaluations, or certification processes.' },
]

const ORGANIZATIONAL_INVEST= [
  { title: "Reduce Security Exposure",desc: 'Identify weaknesses before they become larger operational or business risks.' },
  { title: 'Protect Sensitive Data',desc: 'Strengthen controls around customer, employee, business, and other sensitive information.' },
  { title: "Improve Compliance Readiness", desc: "Prepare applications and processes against relevant standards, guidelines, and regulatory requirements." },
  { title: 'Build Accessible Digital Platforms',   desc: 'Create websites and applications that are more usable and accessible across different user needs.' },
  { title: "Improve Technology Governance",desc: 'Introduce clearer security policies, controls, processes, responsibilities, and documentation.' },
  { title: 'Reduce Costly Rework',          desc: 'Address security, accessibility, and compliance considerations early instead of retrofitting them after development.' },
  
]
function ProcessFlow({ steps, label }) {
  const flowRef = useRef(null)
  const listRef = useRef(null)
  const svgRef = useRef(null)
  const [layout, setLayout] = useState({ start: null, segments: [] })
  // const [reducedMotion] = useState(
  //   () => window.matchMedia('(prefers-reduced-motion: reduce)').matches
  // )
  const reducedMotion = usePrefersReducedMotion()
  const arrowId = `process-arrow-${useId().replace(/:/g, '')}`

  // One path per step-to-step segment, so the dot can travel along each one
  useEffect(() => {
    const flow = flowRef.current
    const list = listRef.current
    if (!flow || !list) return

    const draw = () => {
      const icons = list.querySelectorAll('.process-step__icon')
      if (!icons.length) return

      const flowRect = flow.getBoundingClientRect()
      const points = Array.from(icons, (icon) => {
        const rect = icon.getBoundingClientRect()
        return {
          x: rect.left - flowRect.left + rect.width / 2,
          y: rect.top - flowRect.top + rect.height / 2,
        }
      })

      // Vertical stack on mobile is detected from CSS, so no breakpoint is duplicated here
      const isVertical = getComputedStyle(list).flexDirection === 'column'

      // Stop the arrow at the edge of the last icon so the arrowhead stays visible
      const radius = icons[icons.length - 1].offsetWidth / 2
      const last = points[points.length - 1]
      if (isVertical) last.y -= radius
      else last.x -= radius

      const segments = []
      for (let i = 1; i < points.length; i += 1) {
        const cur = points[i - 1]
        const next = points[i]
        const cx = (cur.x + next.x) / 2
        segments.push(
          isVertical
            ? `M ${cur.x} ${cur.y} L ${next.x} ${next.y}`
            : `M ${cur.x} ${cur.y} C ${cx},${cur.y} ${cx},${next.y} ${next.x},${next.y}`
        )
      }
      setLayout({ start: points[0], segments })
    }

    const observer = new ResizeObserver(draw)
    observer.observe(flow)
    document.fonts?.ready.then(draw)

    return () => observer.disconnect()
  }, [steps])

  // Travelling dot — moves along each segment in turn, then loops
  useEffect(() => {
    const svg = svgRef.current
    const dot = svg?.querySelector('.process-svg__dot')
    const paths = svg ? Array.from(svg.querySelectorAll('.process-svg__path')) : []
    if (!dot || !paths.length) return

  const DURATION = 900
let frame = 0
let index = 0
let phaseStart = null

const moveDot = ({ x, y }) => {
  dot.setAttribute('cx', x)
  dot.setAttribute('cy', y)
}

const run = (now) => {
  if (phaseStart === null) phaseStart = now

  const path = paths[index]
  const length = path.getTotalLength()
  const elapsed = now - phaseStart

  if (elapsed < DURATION) {
   const t = elapsed / DURATION

moveDot(path.getPointAtLength(t * length))
  } else {
    index = (index + 1) % paths.length
    phaseStart = now

    const nextPath = paths[index]
    moveDot(nextPath.getPointAtLength(0))
  }

  frame = requestAnimationFrame(run)
}

    const start = () => { if (!frame) frame = requestAnimationFrame(run) }
    const stop = () => {
      cancelAnimationFrame(frame)
      frame = 0
      phaseStart = null
    }

    // Only animate while the roadmap is on screen
    const observer = new IntersectionObserver(([entry]) =>
      entry.isIntersecting ? start() : stop()
    )
    observer.observe(flowRef.current)

    return () => {
      observer.disconnect()
      stop()
    }
  }, [layout.segments])

  return (
    <div className="process-flow" ref={flowRef}>
      <svg className="process-svg" ref={svgRef} aria-hidden="true" focusable="false">
        <defs>
          <marker id={arrowId} markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon className="process-svg__arrow" points="0,0 6,3 0,6" />
          </marker>
        </defs>
        {layout.segments.map((d, i) => (
          <path
            key={i}
            className="process-svg__path"
            d={d}
            markerEnd={i === layout.segments.length - 1 ? `url(#${arrowId})` : undefined}
          />
        ))}
        {!reducedMotion && layout.start && (
          <circle className="process-svg__dot" r="5" cx={layout.start.x} cy={layout.start.y} />
        )}
      </svg>

      <ol className="process-flow__list" ref={listRef} aria-label={label}>
        {steps.map((step, i) => (
          <li
            key={step.title}
            className={`process-step process-step--${i % 2 === 0 ? 'top' : 'bottom'}`}
            data-aos="fade"
            data-aos-delay={i * 100}
          >
            <span className="process-step__icon" aria-hidden="true">
              <i className={step.icon} />
            </span>
            <div>
              <h6>{step.title}</h6>
              {step.desc && <p className="process-step__desc">{step.desc}</p>}
            </div>
          </li>
        ))}
      </ol>
    </div>
  )
}
const SECURITY_FOCUS_AREAS = [
  { name: 'Web application and API security',    color: { bg: '#f7d3cf', text: '#7a3228' } },
  { name: 'Application architecture and access controls',     color: { bg: '#9bcf60', text: '#2e5a0e' } },
  { name: 'Data protection and privacy',       color: { bg: '#7fc2eb', text: '#1a4f72' } },
  { name: 'Cloud and infrastructure security',     color: { bg: '#a9e5e5', text: '#1a5c5c' } },
  { name: 'Vulnerability and risk management',   color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  { name: 'Accessibility and usability',           color: { bg: '#9bcf60', text: '#2e5a0e' } },
  { name: 'Security policies and governance',      color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  
   { name: 'Compliance and audit readiness',       color: { bg: '#7fc2eb', text: '#1a4f72' } },
  
]
// function buildRows(items) {
//   const rows = []
//   let i = 0, rowIndex = 0
//   while (i < items.length) {
//     const size = rowIndex % 2 === 0 ? 6 : 5
//     rows.push(items.slice(i, i + size))
//     i += size
//     rowIndex++
//   }
//   return rows
// }
export default function SecurityComplianceAdvisory() {
const stackRef   = useRef(null)
    useScrollStack(stackRef, WEB_APPLICATION.length)
  const domainRows = buildRows(SECURITY_FOCUS_AREAS)
  return (
    <>
        {/* <MetaInfo
      title="Security & Compliance Advisory Services | Web Application Security | CruxBytes"
      description="Strengthen web application security, accessibility and compliance with CruxBytes. Get advisory support for GIGW, STQC, WCAG, DPDP and application security requirements."
    /> */}
     <MetaInfo
      title={`${label} ${SITE.metaTagPostText}`} 
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- Application Consulting -</div> */}
             <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* Security & Compliance Advisory */}
              {label}
              </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Expert security and compliance consulting tailored to your business needs. */}
             {pageDesc}
             </p>
             
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
           <section className="bg-linear-gradient-light section-py text-center" >
      <div className="container">
           

        {/* Row 2 — */}
         <p data-aos="fade-up" >
             Security and compliance are fundamental to every modern digital platform. Web applications, APIs, cloud infrastructure, databases, user accounts, and personal data can all introduce security, privacy, and compliance risks. Security should not begin just before deployment. Every application should incorporate security, privacy, accessibility, and compliance considerations across the design, development, testing, deployment, and maintenance lifecycle. This approach helps organizations build digital platforms where security and compliance are considered from the beginning—not added as an afterthought.
         </p>
          <p data-aos="fade-up" data-aos-delay={100}>
             CruxBytes provides Security & Compliance Advisory services to help organizations identify vulnerabilities, strengthen application security, protect sensitive data, and prepare their digital platforms for applicable security and compliance requirements. Our approach combines application security, accessibility, data protection, governance, and compliance readiness to create safer and more dependable digital experiences.
         </p>
        
       
           <div className="pt-4 " data-aos="fade-up" data-aos-delay={200}>              
              
               <h6 >Build Secure, Compliant & Trustworthy Digital Applications</h6>
           </div>
            <p  data-aos="fade-up" data-aos-delay={300}>
             A secure application is not necessarily a compliant application—and compliance should not be treated as a last-minute activity before an audit. Our recommendations are prioritized according to your technology environment, business requirements, risk exposure, and applicable standards.
             
            </p>
<p data-aos="fade-up" data-aos-delay={400}> We help organizations assess and strengthen their technology environment across:</p>
<div className="domain-grid" aria-label="List of industries we serve">
                {domainRows.map((row, rowIdx) => (
                  <div key={rowIdx} className="domain-row">
                    {row.map((domain, chipIdx) => (
                      <span
                        key={domain.name}
                        className="domain-chip"
                        style={{ '--chip-bg': domain.color.bg, '--chip-text': domain.color.text }}
                        data-aos="fade-up"
                        data-aos-delay={chipIdx * 30}
                      >
                        {domain.name}
                      </span>
                    ))}
                  </div>
                ))}
              </div>
            
            
      </div>
    </section>
    <section className="section-py" aria-labelledby="pux-outcomes-heading">
  <div className="container">
    <div className="sc-tm-row sc-tm-row--sticky-heading">

      <div className="sc-tm-content" data-aos="fade-left">
         <h2 id="pux-outcomes-heading" >
        Web Application Security & Compliance
        </h2>
              <p>We work extensively with organizations that require secure, accessible, and compliant web applications and digital platforms, particularly where government, citizen, customer, or sensitive business data is involved.</p>
      </div>
      <div  data-aos="fade-right">
        <div className="ss-cards-panel" ref={stackRef}>
                {WEB_APPLICATION.map((story, idx) => (
                  <article
                    key={story.id}
                    className="ss-card"
                    style={{ '--card-index': idx }}
                    aria-label={story.title}
                  >
                    {/* Left — text */}
                    <div className="ss-card-text">
                      <span className="icon-circle" aria-hidden="true">
                       <i className={`fa-solid ${story.icon}`} /></span>
                      <h3 className="ss-card-title">{story.title}</h3>
                    {[].concat(story.desc).map((para, i) => (
                        <p key={i} className="ss-card-desc">{renderBold(para)}</p>
                      ))}                   
                     
                    </div>                   
                  </article>
                ))}
              </div>
      </div>
     
    </div>
     <p className="pt-5"  data-aos="fade-up">
        Whether you are developing a new web application, modernizing an existing platform, preparing for GIGW or STQC requirements, strengthening WCAG accessibility, or addressing DPDP-related data protection considerations, CruxBytes can help you identify the right priorities and create a practical path forward.
      </p>
      <div className="inner-page-actions">
                          <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right"  data-aos="fade-left">
                           Talk to our security and compliance advisory team
                          </Button>
                        </div>
  </div>
</section>
    {/* section 3 */}
    <section className="bg-peach section-py" aria-labelledby="we-assess-heading">
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <h2 id="we-assess-heading">What We Assess</h2>
        </div>

        <div className="wcs-grid">
                 {ASSESSMENT_AREAS.map((item, i) => (
                   <div
         key={item.title}
         className="wcs-card bg-white"
         data-aos="fade-up"
         data-aos-delay={i * 70}
         role="button"
         tabIndex={0}
         aria-label={`Learn more about ${item.title}`}
          onClick={() => navigate(item.link)}
         onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate(item.link) }}
         onMouseMove={(e) => {
           const card = e.currentTarget;
           const rect = card.getBoundingClientRect();
           const x = e.clientX - rect.left;
           const y = e.clientY - rect.top;
           card.style.setProperty("--x", `${x}px`);
           card.style.setProperty("--y", `${y}px`);
           const rotateY = ((x / rect.width) - 0.5) * 8;
           const rotateX = ((rect.height / 2 - y) / rect.height) * 8;
           card.style.transform = `
             perspective(900px)
             rotateX(${rotateX}deg)
             rotateY(${rotateY}deg)
             translateY(-8px)
           `;
         }}
         onMouseLeave={(e) => {
           const card = e.currentTarget;
           card.style.transition = "transform .45s cubic-bezier(.22,.61,.36,1)";
           card.style.transform = "perspective(900px) rotateX(0deg) rotateY(0deg) translateY(0)";
         }}
       >
                                          <div className="wcs-icon" aria-hidden="true">
                       <i className={`${item.icon}`} />
                       {/* <i class="fa-solid fa-check-double"></i> */}
                     </div>
                     <h3 className="wcs-title">{item.title}</h3>
                     <p className="wcs-desc">{item.desc}</p>
                   
                     
                   </div>
                 ))}
               </div>
      </div>
    </section>
    {/* section 4 */}
      <section className="bgs-section bgs-section--tint section-py" aria-labelledby="bgs-reach-heading2">
          <div className="container">
            <div className="text-center" data-aos="fade-up">
              <h2 id="bgs-reach-heading2">
               From Compliance Gaps to Practical Action
              </h2>
             
            </div>     
    
            {/* Row 2 — */}
            <div className="bgs-row bgs-row--text-only" data-aos="fade-up">
              <div className="bgs-row-content">           
               
                <p className="text-center" >
             Our objective is not simply to identify problems. We help convert findings into a <span className='text-bold'>clear and prioritized improvement plan.</span>
                </p>           
               
              </div>
            </div>
         <ProcessFlow
              steps={PRACTICAL_ACTION}
              label="Our software consulting approach"
            />
          </div>
          
        </section>
        {/* section5 */}
   <section className="section-py" aria-labelledby="we-assess-heading">
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <h2 id="we-assess-heading">Why Organizations Invest in Security & Compliance Advisory</h2>
        </div>

      <div className="comparison-inner-table" role="table" aria-label="Comparison of other providers versus us" data-aos="fade-right">
       
          {ORGANIZATIONAL_INVEST.map(row => (
            <div className="comparison-inner-row" role="row" key={row.title}  >
              <div className="comparison-inner-cell comparison-cell--title" role="cell">
                 <i class="fa-solid fa-circle-check  card-title-icon" aria-hidden="true"></i><span className="comparison-title">{row.title}</span>
              </div>
              <div className="comparison-inner-cell comparison-cell--ours" role="cell">
                {row.desc}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
         <TransformBanner />
         </main>
         </>
  )
}